var React = require('react');

function Celebrate (props) {
    return React.createElement("svg",props,React.createElement("text",{"fill":"#232A31","fillRule":"evenodd","fontFamily":"AppleColorEmoji, Apple Color Emoji","fontSize":"48","letterSpacing":"-1.091","transform":"translate(-583 -66)"},React.createElement("tspan",{"x":"583","y":"110"},"🎉")));
}

Celebrate.defaultProps = {"width":"48","height":"48","viewBox":"0 0 48 48"};

module.exports = Celebrate;

Celebrate.default = Celebrate;



// WEBPACK FOOTER //
// ./src/Assets/Icons/Gymtv/celebrate.svg